import React from "react";
import { Modal, Form, Input } from "antd";
import "./Checkout.scss";

interface AddressModal {
    open: boolean,
    onClose: any,
    onSubmit:any
}



const AddAddressModal = ({ open, onClose, onSubmit }: AddressModal) => {
  const [form] = Form.useForm();

  const handleFinish = (values:any) => {
    console.log("Address submitted:", values);
    if (onSubmit) onSubmit(values);
    form.resetFields();
    onClose();
  };

  return (
    <Modal
      open={open}
      onCancel={() => {
        form.resetFields();
        onClose();
      }}
      footer={null}
      width={581}
      className="add-address-modal"
      centered
      closeIcon={false}
    >
      <h2 className="modal-title">Add new Address</h2>
      <img
            src="/modal-decor.svg"
            className="modal-decor"
            alt=""
          />
      <Form
        form={form}
        layout="vertical"
        onFinish={handleFinish}
        className="address-form"
      >
        {/* Street */}
        <Form.Item name="street" noStyle>
          <div className="field-box">
            <span className="field-label">Street</span>
            <Input
              className="field-input"
              placeholder="Enter Street"
              bordered={false}
            />
          </div>
        </Form.Item>

        {/* Building */}
        <Form.Item name="building" noStyle>
          <div className="field-box">
            <span className="field-label">Building / Floor / Apartment</span>
            <Input
              className="field-input"
              placeholder="Enter Building / Floor / Apartment"
              bordered={false}
            />
          </div>
        </Form.Item>

        {/* City */}
        <Form.Item name="city" noStyle>
          <div className="field-box">
            <span className="field-label">City</span>
            <Input
              className="field-input"
              placeholder="Enter City"
              bordered={false}
            />
          </div>
        </Form.Item>

        {/* State */}
        <Form.Item name="state" noStyle>
          <div className="field-box">
            <span className="field-label">State</span>
            <Input
              className="field-input"
              placeholder="Enter State"
              bordered={false}
            />
          </div>
        </Form.Item>

        {/* Zipcode */}
        <Form.Item name="zipcode" noStyle>
          <div className="field-box">
            <span className="field-label">Zipcode</span>
            <Input
              className="field-input"
              placeholder="Enter Zipcode"
              bordered={false}
            />
          </div>
        </Form.Item>

        <div className="submit-wrap">
          <button type="submit" className="submit-btn">
            Submit
          </button>
        </div>
      </Form>
    </Modal>
  );
};

export default AddAddressModal;
